import React, { Component } from 'react'
import classnames from 'classnames'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import ButtonStyles from '../styles/buttons'

class RBButton extends Component {
  render () {
    let pr = Object.assign({}, this.props)
    let isLoading = pr.loading

    if (isLoading) {
      pr.label = false
    }

    // BUTTON TYPES
    // "text","flat","outlined","contained","raised","fab","extendedFab"

    // PROPTYPES
    // color = colors the text
    // primary = ensures coloured backdrop with white label
    // variant = button type according to material ui
    // styles = additional styles

    const dynamicClasses = {
      fullWidth: pr.fullWidth,
      disabled: pr.disabled,
      color: pr.color,
      primary: pr.primary,
      outlined: pr.variant === 'outlined'
    }

    return (
      <div className={ classnames(pr.classes.container, { flex: pr.useFlex, fullWidth: pr.fullWidth }) }>
        <Button
          type={pr.type}
          variant={pr.variant || 'text'}
          color='primary'
          className={ classnames(pr.classes.base, pr.className, dynamicClasses) }
          aria-label={pr.label}
          onClick={pr.onClick}
          disabled={pr.disabled}
          style={this.props.styles}// need this to pass additional styles dynamically
        >
          {pr.icon ? pr.icon : null}
          {pr.label}
          {isLoading === true ? <CircularProgress size={30} color='inherit' style={{ margin: '0px 10px' }} /> : false}
          {pr.iconRight ? pr.iconRight : null}
        </Button>
      </div>
    )
  }
}

const styles = {
  container: ButtonStyles.buttonContainer,
  base: ButtonStyles.baseButton
}

export default withStyles(styles)(RBButton)



// WEBPACK FOOTER //
// ./src/controls/RBButton.js